// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
import App from './App';
import { AuthProvider, msalInstance } from "./providers/AuthContext";
import { MsalProvider } from '@azure/msal-react';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <AuthProvider>
          <App />
          <Toaster toastOptions={{
            className: 'text-sm font-bold text-black',
            success: {
              iconTheme: {
                primary: '#4CAF50',
                secondary: '#ffffff',
              },
              },
              error: {
                iconTheme: {
                  primary: '#f87171',
                  secondary: '#ffffff',
                },
                },
                loading: {
                  iconTheme: {
                    primary: '#b91c1c',
                    secondary: '#fecaca',
                  },
                  },
          }} />
        </AuthProvider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
